import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('loanIndustryPurposeCache', (http, CacheFactory, config) =>
  new LocalCache({
      provider: () => http.get(`/products/loans/loan-purposes-to-industry`),
      cacheFactory: CacheFactory,
      cacheTime: config.cache.loanPurposesToIndustry,
      cacheName: `loanPurposesToIndustry`
    }
  )
);
